import {fetchTermsRequest} from 'APIs/letrusAPI/terms';
import LoadingQuestion from 'components/LoadingComponents/LoadingQuestion';
import {Term} from 'APIs/letrusAPI/terms/types';
import styles from './Terms.module.scss';

interface TermsModalProps {
  onTermsFetch?(terms?: Term[]): void;
}

function TermsModal({onTermsFetch}: TermsModalProps) {
  const terms = fetchTermsRequest({onSuccess: onTermsFetch});

  function getUseTerms(terms?: Term[]) {
    return terms?.filter((term) => term.parameter === 'terms_use_text')[0];
  }

  return (
    <div className={styles.termsWrapper}>
      <h3>TERMOS E CONDIÇÕES DE USO DA PLATAFORMA LETRUS</h3>

      {terms.isLoading ? (
        <LoadingQuestion />
      ) : (
        <div
          dangerouslySetInnerHTML={{
            __html: getUseTerms(terms.data)?.value ?? '',
          }}
        />
      )}
    </div>
  );
}

export default TermsModal;
